import { ResolverSupportingSlug } from '@core/frontend-shared/utils';
import { Store } from '@ngxs/store';
import { map, switchMap } from 'rxjs/operators';
import { CourseStateFacade } from './course-state.facade';
import { CourseState } from './course.state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "./course-state.facade";
export let CourseResolver = /*#__PURE__*/(() => {
  class CourseResolver extends ResolverSupportingSlug {
    constructor(store, facade) {
      super();
      this.store = store;
      this.facade = facade;
    }
    resolve(route) {
      const id = this.extractId(route, 'id');
      // wait for async selectCourse to complete, then return selectedCourse from store using selectOnce
      return this.facade.selectCourse(id).pipe(switchMap(() => this.store.selectOnce(CourseState.selectedCourseWithProgress)), map(info => {
        if (info.course.teaser) throw new Error('Kurs ist noch nicht verfügbar');
        return info.course;
      }));
    }
    static {
      this.ɵfac = function CourseResolver_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CourseResolver)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.CourseStateFacade));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: CourseResolver,
        factory: CourseResolver.ɵfac
      });
    }
  }
  return CourseResolver;
})();